/**
 * Pinecone injects route HTML without reliably executing inline <script> tags.
 * Wire the OTP reset form after each navigation (and on standalone auth shells).
 */
function fmtRetry(ms) {
  const n = Number(ms);
  if (!Number.isFinite(n) || n <= 0) return 'Try again later.';
  const sec = Math.ceil(n / 1000);
  if (sec < 120) return `Try again in about ${sec} seconds.`;
  const min = Math.ceil(sec / 60);
  return `Try again in about ${min} minute${min === 1 ? '' : 's'}.`;
}

function bindAdminResetOtpFormOnce() {
  const form = document.getElementById('otpResetForm');
  if (!form || form.dataset.pdlBound === '1') return;
  form.dataset.pdlBound = '1';

  const errEl = document.getElementById('otpErr');
  const okEl = document.getElementById('otpOk');
  const btn = document.getElementById('otpSubmit');

  form.addEventListener('submit', (ev) => {
    ev.preventDefault();
    if (errEl) errEl.textContent = '';
    if (okEl) okEl.textContent = '';
    const email = String(document.getElementById('otpEmail')?.value || '').trim();
    const code = String(document.getElementById('otpCode')?.value || '').trim();
    const password = String(document.getElementById('otpPw')?.value || '');
    const password2 = String(document.getElementById('otpPw2')?.value || '');
    if (password.length < 8) {
      if (errEl) errEl.textContent = 'Password must be at least 8 characters.';
      return;
    }
    if (password !== password2) {
      if (errEl) errEl.textContent = 'Passwords do not match.';
      return;
    }
    if (btn) btn.disabled = true;
    let doneOk = false;
    fetch('/api/auth/reset-password-otp', {
      method: 'POST',
      headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify({ email, code, password }),
    })
      .then((r) => r.json().then((j) => ({ r, j })))
      .then(({ r, j }) => {
        if (r.status === 429) {
          let ra = Number(j.retryAfterMs);
          if (!Number.isFinite(ra) && r.headers) {
            const h = r.headers.get('retry-after');
            if (h) ra = Number(h) * 1000;
          }
          throw new Error(j.message || fmtRetry(ra));
        }
        if (!r.ok) throw new Error(j.message || j.error || 'reset_failed');
        doneOk = true;
        if (okEl) {
          okEl.textContent = j.message || 'Password updated. Redirecting to sign in…';
        }
        globalThis.setTimeout(() => {
          globalThis.location.href = '/admin/login';
        }, 1200);
      })
      .catch((e) => {
        if (errEl) errEl.textContent = String(e?.message || 'reset_failed');
      })
      .finally(() => {
        if (btn && !doneOk) btn.disabled = false;
      });
  });
}

document.addEventListener('pinecone:after', () => {
  queueMicrotask(bindAdminResetOtpFormOnce);
});

queueMicrotask(bindAdminResetOtpFormOnce);
